import useTranslation from 'next-translate/useTranslation';
import { FocusEventHandler, useRef, useState } from 'react';
import HeaderWithBackButton from '@/components/HeaderWithBackButton';
import MobileNumberScreen from '@/components/login/MobileNumberScreen';
import OtpScreen from '@/components/login/OtpScreen';

// Gap (px) kept between the top of the screen and the form when it is moved up:
// fixed header + a little breathing room
const FORM_TOP_OFFSET = 83;
interface Props {
  isPopup?: boolean;
  onBack?: VoidFunction;
  onLogin?: VoidFunction;
}
const LoginScreen = ({
  isPopup = false,
  onBack,
  onLogin
}: Props) => {
  const [currentMobileNumber, setCurrentMobileNumber] = useState('');
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const {
    t
  } = useTranslation('login');
  const mainRef = useRef<HTMLElement>(null);
  const onSendOtp = async (mobileNumber: string) => {
    setCurrentMobileNumber(mobileNumber);
    setShowOtpScreen(true);
  };

  /**
   * The fields sit below the banner, in the part of the screen the on-screen
   * keyboard covers, and not every browser/webview resizes or pans the page
   * for the keyboard. So move the form up to the header when a field that low
   * gets focus.
   */
  const moveFormAboveKeyboard: FocusEventHandler<HTMLElement> = ({
    target
  }) => {
    if (!(target instanceof HTMLInputElement) || target.type === 'checkbox') return;
    if (target.getBoundingClientRect().bottom < window.innerHeight / 2) return;

    // Nearest section is the form block rendered below the banner
    const form = target.closest('section');
    if (!form) return;
    const top = form.getBoundingClientRect().top - FORM_TOP_OFFSET;
    if (isPopup) mainRef.current?.scrollBy({
      top
    });else window.scrollBy({
      top
    });
  };
  return <main ref={mainRef} className={`bg-neutral-10 flex min-h-screen pt-[71px] w-full ${isPopup ? 'fixed top-0 left-0 z-50 h-screen overflow-y-auto' : ''}`} data-sentry-component="LoginScreen" data-sentry-source-file="LoginScreen.tsx">
      <HeaderWithBackButton heading={showOtpScreen ? t('otp') : t('login')} onBackClick={showOtpScreen ? () => setShowOtpScreen(false) : isPopup ? onBack : undefined} showHomeIcon={false} showProfileIcon={false} data-sentry-element="HeaderWithBackButton" data-sentry-source-file="LoginScreen.tsx" />
      <section className="flex-1 bg-white m-auto px-4 py-2 max-w-7xl min-h-screen focus-within:pb-80" onFocus={moveFormAboveKeyboard}>
        <section className="flex flex-col max-w-7xl h-full">
          {showOtpScreen ? <OtpScreen mobileNumber={currentMobileNumber} onLogin={onLogin} /> : <MobileNumberScreen onOtpSend={onSendOtp} currentMobileNumber={currentMobileNumber} />}
        </section>
      </section>
    </main>;
};
export default LoginScreen;